import React, {Component} from 'react';
import { connect } from 'react-redux';

import Loading from 'components/Loading';

import {t, dt} from 'l10n';
import { getTokensText } from 'utils/wallet';

import { paymentWithTokens } from 'reducers/memberWalletCharge';

class ContentWalletCharge extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingPayment: false
        };
    }

    payWithTokens() {
            const { 
                hash,
                order_id,
                dispatch,
            } = this.props;

            const params = {
                order_id: +order_id,
                hash: hash
            };

            this.setState({pendingPayment: true})

            let action = paymentWithTokens(params);
            dispatch(action);
                    
            action.promise
                .then((res) => {
                    !res.data.message ? location.assign(res.data.data.return_url) : false;
                    this.setState({pendingPayment: false});
                })
                .catch((e) => this.setState({pendingPayment: false}));
    }

    goBack() {
        const { data } = this.props.memberWalletCharge;

        location.assign(data.return_url);
    }

    render() {
        const { pendingPayment } = this.state;

        const { 
            data,
            status,
            message,
            payment,
        } = this.props.memberWalletCharge;

        if(payment) return <Loading centered/>;

        const amount_required = <span>{dt('xxl', '%1 tokens', data.amount_required)}</span>;
        const order_id = <span>{`${data.order_id}`}</span>;
        const amount_available = <span>{dt('xxl', '%1 tokens', data.amount_available)}</span>;

        return (
            <div className="charge">
                <div className="content">
                    <div className="messages">
                        {!message ? (
                            <div>
                                <p dangerouslySetInnerHTML={{__html:t(`You are going to spend %1 for <a href="https://bobstore.fr">Bobstore.fr</a> order %2.`, amount_required, order_id)}} />
                                <p dangerouslySetInnerHTML={{__html:t(`You have %1 available at your wallet.`, amount_available)}} />
                            </div>
                        ) : (
                            <p className="error" dangerouslySetInnerHTML={{__html:t(`${message}`)}} />
                        )}
                    </div>
                    <div className="actions">
                        {!message ? <button className={`ui-button primary btn-submit ${pendingPayment ? 'loader' : ''}`} onClick={() => this.payWithTokens()}>{!pendingPayment ? t('Confirm') : null}</button> : null}
                        <button className="ui-button primary btn-submit" onClick={() => this.goBack()}>{t('Cancel')}</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({

    }),
    null
)(ContentWalletCharge)


// WEBPACK FOOTER //
// ./src/components/walletcharge/ContentWalletCharge.js